import { render, staticRenderFns } from "./page.vue?vue&type=template&id=24cbe93c&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=24cbe93c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cbe93c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24cbe93c')) {
      api.createRecord('24cbe93c', component.options)
    } else {
      api.reload('24cbe93c', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=24cbe93c&scoped=true&", function () {
      api.rerender('24cbe93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/entries/co-pilot/routes/profile/page.vue"
export default component.exports